import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { IRoute } from '../../../App';
import { chordPrefix, chordsFor } from '../../../services/shortcuts/navigationChords';
import { useShortcuts } from '../../../services/shortcuts/useShortcut';
import {
  SmallDeviceContext,
  SmallDeviceShow,
} from '../../../services/smallDevices/smallDeviceService';

/**
 * `g` then a letter goes to a page. See navigationChords for the letters.
 *
 * Mounted once, in AppInner, which is inside the router. On a phone the
 * navigation drawer may be open; the page is what was asked for, so it is
 * put in front. A chord for the page already showing does nothing rather
 * than adding a history entry to nowhere.
 */
export default function useNavigationShortcuts(routes: readonly IRoute[]) {
  const navigate = useNavigate();
  const smallDevSvc = useContext(SmallDeviceContext);

  useShortcuts(
    chordsFor(routes).map((chord) => ({
      id: `go-to:${chord.path}`,
      keys: { key: chord.key, prefix: chordPrefix },
      group: 'Navigation' as const,
      description: chord.description,
      run: () => {
        smallDevSvc.setState(SmallDeviceShow.Main);

        if (window.location.pathname !== chord.path) {
          navigate(chord.path);
        }
      },
    })),
  );
}
